import * as constants from "../utils/constants";
import { enableDemo } from "../env";

export default {
  auth: {
    success: false,
    loading: false,
  },
  checkin: {
    auth: {
      success: false,
      token: "",
      expires: "",
      success: false,
    },
    reservation: {},
    customer: {},
    estimate: {},
    options: {},
    details: {},
    toast: { type: "", message: "" },
    regions: constants.REGIONS,
    addressSuggestions: [],
    selectedAddress: {},
    verifyEmail: false,
    verifyPhone: false,
    windcave: {},
    idVerification: {},
    requireReVerifyCC: false,
    requireReVerifyID: false,
    isDemo: enableDemo,
    isAdditionalDriver: false,
    ocrLabsOutage: [],
    idVerificationSkipped: false,
    finalPageSMSSent: false
  },
  app: {
    loading: false,
    loginRental: "",
    currentRental: "",
    rentals: [],
    toast: { type: "", message: "" },
    popper: true,
  },
  vir: {
    athenaAuth: { loading: false },
    athenaVirAuth: { loading: false },
    athenaVirUser: { loading: false },
    athenaVirServiceTracking: { loading: false },
    athenaVirDetailPatch: { loading: false },
    athenaDamagePresigned: { loading: false },
    athenaDamageZipPhotos: { loading: false },
    athenaVirCreate: { loading: false },
    athenaVirResubmit: { flag: false },
    athenaVirDetail: { loading: false },
    athenaApp: { loading: false },
    athenaSource: { source: "web" },
    virSendContact: { loading: false },
    athenaRole: { role: "customer" },
    virPrepareBE: {},
    athenaSelectedType: {},
    athenaSelectedId: {},
    virPrepareTHERMEON: {},
    athenaReportType: {},
  },
  rental: {
    rentalVehicle: {},
    errorAlert: false,
    eligibleFlag: true,
  },
};
